"use client"

import { MapPin } from 'lucide-react'
import { useState } from 'react'

type ProjectLocationProps = {
  location: string
  comuna?: string
  // We can add coordinates later if available
  coordinates?: {
    lat: number
    lng: number
  }
}

export default function ProjectLocation({ location, comuna, coordinates }: ProjectLocationProps) {
  // Track if the image has failed to load to prevent infinite error loops
  const [mapImageFailed, setMapImageFailed] = useState(false)
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-lg font-semibold text-[#004132] mb-4 flex items-center">
        <MapPin className="w-5 h-5 mr-2" />
        Ubicación
      </h2>
      
      <p className="text-gray-700 mb-4" data-component-name="ProjectDetailPage">{comuna || location || 'Ubicación no especificada'}</p>
      
      {/* Map placeholder - can be replaced with an actual map component later */}
      <div className="relative w-full h-[300px] bg-gray-100 rounded-lg overflow-hidden">
        {coordinates ? (
          // If we have coordinates, we can use a real map
          <div className="absolute inset-0 bg-gray-200 flex items-center justify-center">
            <p className="text-gray-500">Mapa con ubicación exacta se cargará aquí</p>
          </div>
        ) : mapImageFailed ? (
          // If the map image failed to load, show a fallback container
          <div className="absolute inset-0 bg-gray-100 flex items-center justify-center">
            <p className="text-gray-500">No se pudo cargar el mapa</p>
          </div>
        ) : (
          // Use a colored div with location text as a reliable fallback
          <div className="absolute inset-0 bg-gray-200 flex flex-col items-center justify-center">
            <MapPin className="w-12 h-12 text-green-700 mb-2" />
            <p className="text-gray-700 font-medium text-center px-4">{comuna || location || 'Ubicación no especificada'}</p>
            <p className="text-sm text-gray-500 mt-2">Ver en mapa</p>
          </div>
        )}
      </div>
      
      <div className="mt-4">
        <h3 className="font-medium text-[#004132] mb-2">Puntos de interés cercanos</h3>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
          <li className="flex items-center">
            <div className="w-2 h-2 bg-[#e6fa41] rounded-full mr-2"></div>
            <span className="text-gray-700">Supermercados</span>
          </li>
          <li className="flex items-center">
            <div className="w-2 h-2 bg-[#e6fa41] rounded-full mr-2"></div>
            <span className="text-gray-700">Transporte público</span>
          </li>
          <li className="flex items-center">
            <div className="w-2 h-2 bg-[#e6fa41] rounded-full mr-2"></div>
            <span className="text-gray-700">Parques</span>
          </li>
          <li className="flex items-center">
            <div className="w-2 h-2 bg-[#e6fa41] rounded-full mr-2"></div>
            <span className="text-gray-700">Centros comerciales</span>
          </li>
        </ul>
      </div>
    </div>
  )
}
